import { render, staticRenderFns } from "./Taggregator.vue?vue&type=template&id=0f91df3c"
import script from "./Taggregator.vue?vue&type=script&lang=js"
export * from "./Taggregator.vue?vue&type=script&lang=js"
import style0 from "./Taggregator.vue?vue&type=style&index=0&id=0f91df3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports